export default __webpack_public_path__ + "static/media/blocklist_locations_icons_residential.b414954c.svg";